package com.heelion.farmafreelance.voice

import androidx.compose.runtime.Composable

@Composable
actual fun rememberVoiceRecognizer(): VoiceRecognizer = WebVoiceRecognizer

/** Usa la Web Speech API del browser (Chrome/Edge; Safari solo dietro flag). Nessun costo. */
private object WebVoiceRecognizer : VoiceRecognizer {

    override fun isAvailable(): Boolean = js(
        "typeof window !== 'undefined' && !!(window.SpeechRecognition || window.webkitSpeechRecognition)"
    ) as Boolean

    override fun startListening(onResult: (String) -> Unit, onError: (String) -> Unit) {
        if (!isAvailable()) {
            onError("Il riconoscimento vocale non è supportato da questo browser.")
            return
        }
        startWebSpeechRecognition(onResult, onError)
    }
}

private fun startWebSpeechRecognition(onResult: (String) -> Unit, onError: (String) -> Unit) {
    val recognition = js(
        "new (window.SpeechRecognition || window.webkitSpeechRecognition)()"
    )
    recognition.lang = "it-IT"
    recognition.interimResults = false
    recognition.maxAlternatives = 1

    recognition.onresult = { event: dynamic ->
        val transcript = event.results[0][0].transcript as String
        onResult(transcript)
    }
    recognition.onerror = { _: dynamic ->
        onError("Non ho capito, riprova.")
    }

    recognition.start()
}
